import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TraceabilityFieldComponent } from './traceability-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    TraceabilityFieldComponent,
  ],
  exports: [
    TraceabilityFieldComponent,
  ],
})
export class TraceabilitiesExportModule {}
